module.exports = __webpack_public_path__ + "img/744.348e984a.jpg";